
import { Directive, OnInit, Optional, Self, Input } from '@angular/core';
import { FrameContext } from '@farris/devkit';
import { LookupGridComponent } from '@farris/ui-lookup';

// tslint:disable-next-line: directive-selector
@Directive({
  selector: '[enableExtendLoadMethod]'
})
export class LookupEnableExtendLoadMethodDirective implements OnInit {
  @Input()
  public enableExtendLoadMethod: any;

  constructor(
    @Optional() private frameContext: FrameContext,
    @Optional() @Self() private lookup: LookupGridComponent
  ) { }

  ngOnInit() {
    if (!this.frameContext || !this.lookup || this.enableExtendLoadMethod !== true) {
      return;
    }
    const befApiUrl = this.frameContext.repository.apiUri;
    const helpMetadataId = this.lookup.uri;
    const enableKey = `${helpMetadataId}@${befApiUrl}`;
    this.frameContext.setParam(enableKey, true);
  }
}
